import BillingModel from "../../../types/billing-model";
import BillingFormData from "../types/billing-form.data";
import BillingsNode from "../../../common/types/billings-node";
import googleMapsRouteService from "../../../../../common/utils/google-maps-route/google-maps-route.service";
import BillingsOrderCargoRailyRecalculate, {
  BillingsOrderCargoRailyRecalculateBillingNode,
  BillingsOrderCargoRailyRecalculateContract,
} from "../../../../../common/services/billings/order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate";
import ContractDetails from "../types/contract-details";

const createBillingNodes = (
  data: BillingsOrderCargoRailyRecalculateBillingNode[],
): BillingsNode[] => {
  return data.map((billingNode, index) => {
    const previousItem = index - 1 >= 0 ? data[index - 1] : null;

    const url =
      previousItem !== null
        ? googleMapsRouteService.createGoogleMapsRouteUrl([
            { latitude: previousItem.lat, longitude: previousItem.lon },
            { latitude: billingNode.lat, longitude: billingNode.lon },
          ])
        : "";

    const result: BillingsNode = {
      id: billingNode.id,
      nodeId: billingNode.nodeId,
      lat: billingNode.lat,
      lon: billingNode.lon,
      description: billingNode.description,
      checkoutDate: billingNode.checkoutDate,
      checkoutEventUuid: billingNode.checkoutEventId,
      plannedDate: billingNode.plannedDate,
      plannedDistance: billingNode.plannedDistance,
      orderId: `${billingNode.orderId}`,
      distance: billingNode.distance,
      haltingTime: billingNode.haltingTime,
      highwayCharge: billingNode.highwayCharge,
      isHighwayAllowed: billingNode.allowCharge,
      isEditable: billingNode.editableCoordinates,
      googleMapsUrl: url,
      position: index + 1,
    };

    return result;
  });
};

const createBillingRecalculateDataContractDetails = (
  contract: BillingsOrderCargoRailyRecalculateContract,
): ContractDetails => {
  return {
    companyName: contract.cargoCompany.companyName,
    discountLimit: contract.discountLimit,
    haltingTimeRate: contract.haltingTimeAfterMinutes,
    distanceRate: contract.distanceRate,
    isHighwayAllowedDuringRide: contract.allowChargeDuringRide,
    isHighwayAllowedWhenApproaching: contract.allowChargeWhileApproaching,
    isHighwayAllowedWhileReturning: contract.allowChargeWhileReturning,
    model: contract.model,
    haltingTimeAppliedAfter: contract.haltingTimeAfterMinutes,
  };
};

const createBillingRecalculateData = (
  billingData: BillingsOrderCargoRailyRecalculate,
): BillingFormData => {
  return {
    billingNodes: createBillingNodes(billingData.billingNodes),
    contractDetails: createBillingRecalculateDataContractDetails(
      billingData.contract,
    ),
    discountAmount: billingData.discountAmount,
    haltingCost: billingData.haltingAmount,
    highwayCharge: billingData.highwayCharge,
    distance: billingData.distance,
    routeDistanceCost: billingData.distanceAmount,
    internalOrderId: billingData.cargoOrder.humanId,
    discount: billingData.discount,
    total: billingData.totalAmount,
    planEntryId: billingData.planEntryId,
    cargoOrderId: billingData.cargoOrder.id,
    date: billingData.date,
  };
};

const billingRecalculateDataFactory = {
  createBillingRecalculateData,
};

export default billingRecalculateDataFactory;
